import { render, staticRenderFns } from "./ChartPlotLegend.vue?vue&type=template&id=646e6f42&scoped=true"
import script from "./ChartPlotLegend.vue?vue&type=script&lang=js"
export * from "./ChartPlotLegend.vue?vue&type=script&lang=js"
import style0 from "./ChartPlotLegend.vue?vue&type=style&index=0&id=646e6f42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "646e6f42",
  null
  
)

export default component.exports